import fetchManager from '@utils/fetchManager'
import { urlQueryData, getEnvironment } from '@utils/general'

const API_URL = getEnvironment("API_DOMAIN");
// const API_URL = 'http://localhost:8083'

export default {
  getListLanguages: async (querys) => {
    const url = urlQueryData(`${API_URL}/CatalogueManagement/api/amx/cpe/languages`, querys)
    const options = {
      sendToken: false
    }
    const response = await fetchManager(url, options)
    return response
  },
  getDictionaryLanguage: async (clave) => {
    const options = {
      sendToken: false
    }
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/languages/dictionary/${clave}`, options)
    return response
  },
  reOrderLanguage: async (data) => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/languages/order`, {
        method: 'PATCH',
        data,
      })
    return response
  },
  addCLanguage: async (data) => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/languages`, {
        method: 'POST',
        data,
      })
    return response
  },
  editLanguage: async (data) => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/languages`, {
        method: 'PUT',
        data,
      })
    return response
  },
  deleteLanguage: async (clave, data) => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/languages/${clave}`, {
        method: 'DELETE',
        data,
      })
    return response
  },
  updateVisibilityLanguage: async (clave, data) => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/languages/visibility/${clave}`, {
        method: 'PATCH',
        data,
      })
    return response
  },
  updateTextDictionary: async (clave, data) => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/languages/dictionary/${clave}`, {
        method: 'PATCH',
        data,
      })
    return response
  },
  getListDictionariesProcessLanguage: async () => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/languages/process`)
    return response
  },

  getDictionaryProcess: async (clave, querys) => {
    const url = urlQueryData(`${API_URL}/CatalogueManagement/api/amx/cpe/languages/process/dictionary/${clave}`, querys)
    const response = await fetchManager(url)
    return response
  },
  updatetextDictionaryProcess: async (clave, data) => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/languages/process/dictionary/${clave}`, {
        method: 'PATCH',
        data,
      })
    return response
  },
  deleteTextDictionary: async ( data) => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/languages/dictionary`, {
        method: 'DELETE',
        data,
      })
    return response
  },
  deleteTextProcessDictionary: async ( data) => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/languages/process/dictionary`, {
        method: 'DELETE',
        data,
      })
    return response
  },
  addTextDictionary: async ( newTextObj) => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/languages/dictionary/merge`, {
        method: 'PUT',
        data: newTextObj,
      })
    return response
  },
  addTextProcessDictionary: async (data) => {
    const response = await fetchManager(`${API_URL}/CatalogueManagement/api/amx/cpe/languages/process/dictionary/merge`, {
        method: 'PUT',
        data,
      })
    return response
  },
}